import { apiRequest } from '../../lib/api'
import type { ActivityLog } from '@/types/settings'
import type {
  AdminPermissionGrouped,
  AdminRoleAssignmentListEnvelope,
  AdminRoleEnvelope,
  AdminRoleListEnvelope,
  AdminUser,
  AdminUserEnvelope,
  AdminUserListEnvelope,
} from './types'


// All platform users
export async function fetchAllAdminUsers(params?: { role?: string; search?: string; page?: number }) {
  const query = new URLSearchParams()
  if (params?.role) query.set('role', params.role)
  if (params?.search) query.set('search', params.search)
  if (params?.page) query.set('page', String(params.page))
  const qs = query.toString()
  return apiRequest<AdminUserListEnvelope>(`/v1/admin/all-users${qs ? `?${qs}` : ''}`)
}

export async function fetchAdminUserActivityLogs(userId: string) {
  return apiRequest<{ data: ActivityLog[] }>(`/v1/admin/users/${userId}/activity-logs`)
}

// Super-admin users
export async function fetchAdminUsers(params?: { search?: string; page?: number }) {
  const query = new URLSearchParams()
  if (params?.search) query.set('search', params.search)
  if (params?.page) query.set('page', String(params.page))
  const qs = query.toString()
  return apiRequest<AdminUserListEnvelope>(`/v1/admin/users${qs ? `?${qs}` : ''}`)
}

export async function fetchAdminUser(userId: string) {
  return apiRequest<AdminUserEnvelope>(`/v1/admin/users/${userId}`)
}

export async function createAdminUser(payload: { display_name: string; email: string; role_slug: string }) {
  return apiRequest<{ message: string; data: AdminUser }>('/v1/admin/users', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  })
}

export async function suspendAdminUser(userId: string, reason: string) {
  return apiRequest<{ message: string }>(`/v1/admin/users/${userId}/suspend`, {
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ reason }),
  })
}

export async function resendAdminInvitation(userId: string) {
  return apiRequest<{ message: string }>(`/v1/admin/users/${userId}/resend-invitation`, {
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({}),
  })
}

export async function reactivateAdminUser(userId: string) {
  return apiRequest<{ message: string }>(`/v1/admin/users/${userId}/reactivate`, {
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({}),
  })
}

// Roles
export async function fetchAdminRoles() {
  return apiRequest<AdminRoleListEnvelope>('/v1/admin/roles')
}

export async function fetchAdminRole(roleId: string) {
  return apiRequest<AdminRoleEnvelope>(`/v1/admin/roles/${roleId}`)
}

// Permissions
export async function fetchAdminPermissions() {
  return apiRequest<AdminPermissionGrouped>('/v1/admin/permissions')
}

// Role assignments
export async function fetchUserRoleAssignments(userId: string) {
  return apiRequest<AdminRoleAssignmentListEnvelope>(`/v1/admin/users/${userId}/roles`)
}

